export enum EventType {
  Comment = 'comment-',
  Update = 'update-'
}

const findEventId = (fragment: string, eventType: EventType): string | null => {
  if (!fragment) return null;

  let matchArray = null;
  switch (eventType) {
    case EventType.Comment:
      matchArray = fragment.match(/comment-[0-9]+([^-]+)/g);
      break;
    case EventType.Update:
      matchArray = fragment.match(/update-[0-9]+([^-]+)/g);
      break;
  }

  if (!matchArray) return null;

  return matchArray[0].replace(eventType, '');
};

export default findEventId;
